interface InsuranceSuccessModalProps {
  isOpen: boolean
  onClose: () => void
}

export function InsuranceSuccessModal({
  isOpen,
  onClose,
}: InsuranceSuccessModalProps) {
  if (!isOpen) {
    return null
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Overlay */}
      <button
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="relative z-10 bg-white rounded-lg max-w-md w-full sm:w-[375px] h-auto sm:h-[355px] p-6">
        <div className="flex flex-col items-center justify-center py-8">
          <div className="px-2 text-center">
            <h2 className="text-[#101010] text-xl font-medium mb-4">
              Seguro adicionado ao carrinho!
            </h2>
            <p className="text-sm text-[#616161] font-normal mb-5">
              Após a confirmação do pagamento, nosso parceiro Clube Santuu
              entrará em contato por e-mail para solicitar uma foto do número de
              série da sua bike e uma foto da própria bike
            </p>
            <p className="text-sm text-[#616161] font-normal mb-7">
              Assim que essas informações forem enviadas, seu seguro será
              ativado.
            </p>
          </div>
          <button
            className="w-full h-12 rounded-full text-white text-base font-semibold bg-[#101010]"
            onClick={onClose}
            type="button"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  )
}
